import { styled } from '@mui/material';
import Box from '@mui/material/Box';

import { IconButton } from '@knowz/knowz-ui';

export const StyledWrapperBox = styled(Box)(({ theme }) => ({
  paddingBlock: theme.spacing(1.5),
  overflowY: 'auto',
  height: '100%',
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(4),
  right: theme.spacing(4),
  zIndex: 2,
}));

export const StyledBox = styled(Box)(() => ({
  height: '100%',
  overflowY: 'auto',
}));
